import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b7ce4f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "form__floating-label"
};
const _hoisted_2 = { class: "label" };
export default /*#__PURE__*/ _defineComponent({
    __name: '_BaseFloatingLabel',
    props: {
        label: String
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.label)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
